function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
var statusMapping = {
  All: "",
  "Order Placed": "CREATED",
  Shipped: "DISPATCHED",
  Delivered: "DELIVERED"
};
var useData = function useData(_ref) {
  var orderStatus = _ref.orderStatus,
    winnreAuth = _ref.winnreAuth,
    appType = _ref.appType,
    _ref$isRewards = _ref.isRewards,
    isRewards = _ref$isRewards === void 0 ? false : _ref$isRewards,
    _ref$isPoints = _ref.isPoints,
    isPoints = _ref$isPoints === void 0 ? false : _ref$isPoints;
  var _useState = useState([{
      dealDisplayImageUrl: "",
      dealTitle: "Y=Test",
      deliveryDetails: {
        trackingId: 1,
        customerName: "MB",
        mobileNumber: 8898,
        shippingAddress: {
          country: "India",
          pincode: 110092,
          state: "Delhi",
          city: "Delhi",
          lin1: "112",
          line2: "cv",
          userName: "mb"
        }
      },
      payment: {
        amount: 1123132
      }
    }]),
    _useState2 = _slicedToArray(_useState, 2),
    orders = _useState2[0],
    setOrders = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loadingOrders = _useState4[0],
    setLoadingOrders = _useState4[1];
  var isAuthenticated = useSelector(function (state) {
    return state.auth.isAuthenticated;
  });
  var _useState5 = useState(1),
    _useState6 = _slicedToArray(_useState5, 2),
    totalPages = _useState6[0],
    setTotalPages = _useState6[1];
  var _useState7 = useState(1),
    _useState8 = _slicedToArray(_useState7, 2),
    currentPage = _useState8[0],
    setCurrentPage = _useState8[1];
  var getAllOrders = function getAllOrders() {
    setLoadingOrders(true);
    var backendStatus = statusMapping[orderStatus];
    var appTypeParam = appType ? "&appType=".concat(appType.toUpperCase()) : "";
    winnreAuth({
      method: "GET",
      url: "/winnre/user/reward-redemption?pageNumber=".concat(currentPage - 1, "&pageSize=4").concat(isPoints ? "&rewardType=RELOY_REWARDS" : "&rewardType=REFERRAL_REWARDS").concat(orderStatus === "All" ? "" : "&statuses=".concat(backendStatus)).concat(appTypeParam)
    }).then(function (res) {
      console.log("all orders", res);
      setLoadingOrders(false);
      setTotalPages(res === null || res === void 0 ? void 0 : res.totalPages);
      setOrders(res === null || res === void 0 ? void 0 : res.content);
    })["catch"](function (err) {
      console.log(err);
      toast.error("Something went wrong. Please try again");
    });
  };
  useEffect(function () {
    getAllOrders();
  }, [orderStatus, isPoints, isRewards, appType, currentPage]);
  return {
    orders: orders,
    loadingOrders: loadingOrders,
    currentPage: currentPage,
    totalPages: totalPages,
    setCurrentPage: setCurrentPage
  };
};
export default useData;